import React, { forwardRef } from 'react';
import { useDispatch } from 'react-redux';

import { authActions } from 'app-components/flux/auth';
import { getCommonConfig } from 'app-components/utils/core';

import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SlowMotionVideoRoundedIcon from '@mui/icons-material/SlowMotionVideoRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import type { ToolbarProps } from '@mui/material/Toolbar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const DemoModeBar = forwardRef<HTMLDivElement, ToolbarProps>((_props, ref) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <Toolbar
      ref={ref}
      variant='dense'
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.primary.light,
      }}
    >
      <Box display='flex' gap={2} alignItems='center'>
        <Typography variant='captionRegular'>{"You're on"}</Typography>
        <Chip icon={<SlowMotionVideoRoundedIcon />} label='Test Drive' size='small' color='success' />
      </Box>

      <Box display='flex' gap={2} alignItems='center'>
        <Typography variant='paragraphRegular'>Ready to purchase?</Typography>
        <Button variant='contained' component='a' href={getCommonConfig()?.external?.purchase} target='_blank'>
          Get Started
        </Button>
        <Button
          startIcon={<ExitToAppIcon />}
          onClick={() => dispatch(authActions.authLogout({ reason: 'AUTH_LOGOUT_DEMO_USER' }))}
          variant='outlined'
        >
          Exit Demo
        </Button>
      </Box>
    </Toolbar>
  );
});

DemoModeBar.displayName = 'DemoModeBar';
export default DemoModeBar;
